<template>
	<section class="slider hideme">
		<div class="carousel slide carousel-fade hideme" data-ride="carousel">
			<div class="carousel-inner">
				<div class="item" v-for="(slide, idx) in sliderContent" :class="{'active': idx == 0}">
					<div class="quote top"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/icon-quote-top.png" alt="quote"></div>
					<div>
						<p style="text-align: center">{{slide.text}}</p>
					</div>
					<div class="quote bottom"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/icon-quote-bottom.png" alt="quote"></div>
					<div class="byline">{{slide.author}}</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
	export default {
		name:'slider-quote',
		props: {
			sliderContent: {
				required: false,
				type: Array
			}
		},
		data: function() {
			return {}
		},
		methods: {
		},
		mounted: function() {
		}
	}
</script>


// WEBPACK FOOTER //
// SliderQuote.vue?6a40014e